module.exports = __webpack_public_path__ + "static/media/upload.db2382c2.svg";